export default __webpack_public_path__ + "static/media/decal-accept.34d5c0cc.png";